<template lang="pug">
  div
</template>

<script>

export default {
  components: {

  },
  methods: {
    handleCallback () {
      const error = this.$route.query.error
      window.opener.postMessage(
        {
          data: 'auth_failure',
          errorMsg: error
        },
        '*'
      )
      parent.close()
    }
  },
  mounted () {
    this.handleCallback()
  }
}
</script>
